import { AntSpin } from '@/components/UIKits/Spin/styles'

export default AntSpin
